export default {
  saasLite: 'SAAS LITE',
  enterprise: 'ENTERPRISE',
  fullService: 'FULL SERVICE',
  legacyDonation: 'LEGACY DONATION',
};
